if (!window.fetch) window.fetch = require('.').default || require('.');



//////////////////
// WEBPACK FOOTER
// /Users/darlacameron/projects/feature-federal-children-shelters-2018-06/node_modules/unfetch/polyfill.js
// module id = 27pi
// module chunks = 4